export default {
    welcomeWord: 'Online Design Tool for 3D-Printed Microfluidics',
}